export default {
  emulated_date: null,
  env: 'production' 
}
